export default __webpack_public_path__ + "static/media/contact-bg-m.a6258016.png";